export enum QueryKeys {
  USER_PROFILE = "user/profile",
  APPROVERS = "approvers",
  AIRLINES = "airlines",
  CUSTOMERS = "agency/customers",
  AGENCIES = "agencies",
  PERCENTAGE_BY_ITEM = "percentage-byitem",
  AMENITIES = "amenities",
  ROUTE_ANALYSIS = "route-analysis",
  BY_PROJECT = "by_project",
  BY_PHASE = "by_phase",
  AGENCY = "agency",
  BY_UNITY = "by-unity",
  CUSTOMER_BI = "customerBI",
  TOP_ROUTES = "top-routes",
  LAST_PURCHASE = "customer-by/lastPurchase",
  TOTAL_SPENT = "customer-by/totalSpent",
  AIRWAY_ITEM = "customer-byirwayItem",
  HOTEL_ITEM = "hotelItem",
  ROAD_ITEM = "roadItem",
  VEHICLE_ITEM = "customer-by/vehicleItem",
  BY_ISSUER = "customer-bi/byIssuer",
  LEAD_TIME = "customer-bi/leadTime",
  BY_COST_CENTER = "customer-bi/byCostCenter",
  ACTION = "action",
  CUSTOMER = "customer",
  ISSUERS = "issuers",
  TRAVELERS = "travelers",
  EXPENSE_CATEGORIES = "expense-categories",
  POLICY_PARAMETER_EXPENSES = "policy-parameter-expenses",
  UNITY_OF_PROJECT = "unity-of-project",
  AGENCY_EMPLOYEES = "agency/agency-employees",
  AGENCY_FEES = "agency/agency-fees",
  AGENCY_MARKDOWNS = "agency/markdowns",
  AGENCY_MARKUPS = "agency/markups",
  CUSTOMER_JUSTIFICATIONS = "customer/customer-justifications",
  CUSTOMER_REASON_TRIPS = "customer/customer-reason-trips",
  CUSTOMER_PHASES = "customer/customer-phases",
  CUSTOMER_COST_CENTERS = "customer/customer-cost-centers",
  CUSTOMER_EXPENSE_TYPES = "customer/customer-expense-types",
  CUSTOMER_EMPLOYEES = "customer/customer-employees",
  CUSTOMER_POLICIES = "customer/policies",
  CUSTOMER_EXPENSE_POLICIES = "customer/expense-policies",
  CUSTOMER_BRANCHES = "customer/branches",
  CUSTOMER_APPROVAL_MODELS = "customer/approval-models",
  CUSTOMER_APPROVAL_MODEL = "customer/approval-model",
  STATE_CITIES = "state/cities",
  CUSTOMER_ORDERS = "customer/orders",
  AGENCY_PENDING_ORDERS = "agency/pending-orders",
  ORDERS = "orders",
  ORDER_TAX_CANCELLATION = "order/tax-cancellation",
  ORDER_MESSAGES = "order/messages",
  ORDER_ACCOUNTABILITY_EXPENSES = "order/accountability-expense",
  ORDER_HOTEL = "order/hotel",
  ORDER_AIRWAY = "order/airway",
  ORDER_VEHICLE = "order/vehicle",
  ORDER_ROAD = "order/road",
  ORDER_ROAD_REBOOK = "order/road/rebook",
  ORDER_ADVANCE = "order/advance",
  ORDER_EXPENSE = "order/expense",
  CALENDAR_PICKER = "calendar-picker",
  ORDER_HISTORY = "order/history",
  QUERY_ROAD = "query/road",
  QUERY_HOTEL = "query/hotel",
  HOTEL = "booking/hotels",
  QUERY_HOTEL_DETAILS = "query/hotel-details",
  HOTEL_DETAILS = "booking/hotel/details",
  QUERY_HOTEL_ROOM_RULES = "query/hotel-rules",
  HOTEL_ROOM_RULES = "booking/hotel/rules",
  FLIGHT_DETAILS = "booking/flight/details",
  ROADS_GO = "booking/roads/go",
  ROADS_RETURN = "booking/roads/return",
  ROAD_SEATS = "booking/road/seats",
  QUERY_HOTELS = "query/hotels",
  QUERY_FLIGHTS = "query/flights",
  QUERY_FLIGHTS_LINKS = "query/flights/links",
  QUERY_VEHICLES = "query/vehicles",
  QUERY_LINKS_FLIGHTS = "query-links/flights",
  QUERY_FLIGHTS_GO = "query/flights/departure",
  QUERY_FLIGHTS_RETURN = "query/flights/arrival",
  QUERY_FLIGHTS_COMBINED = "query/flights/combined",
  QUERY_LINKS_ROADS = "query-links/road",
  QUERY_LINK_REPORT = "query-link/report",
  QUERY_ROADS_GO = "query/roads/go",
  QUERY_ROADS_RETURN = "query/roads/return",
  QUERY_LINKS_ROAD_SEATS = "query-links/roads/seats",
  CURRENT_TIME = "current-time",
  REPORTS = "reports",
  AIRWAYSEATS = "airway-seats",
  MARKUP_PER_CUSTOMER = "markup-per-customer",
  FEE_PER_CUSTOMER = "fee-per-customer",
  PROFILES = "profiles",
  PROFILE_ACTIONS = "profile-actions",
  OFFLINE_HOTEL = "offline-hotel",
  OFFLINE_HOTELS = "offline-hotels",
  OFFLINE_HOTEL_ROOM = "offline-hotel-room",
  OFFLINE_HOTEL_ROOMS = "offline-hotel-rooms",
  HOTEL_SUGGESTIONS = "hotels/suggestions",
  UNFLOWNS_AIRWAYS = "unflowns-airways",
  BUDGETS = "customer/budgets",
  BUDGETS_VIEW = "customer/budgets/view",
  ORDER_BUDGET_BALANCE = "order/budget-balance",
  PAYMENT_METHOD = "offline-payment",
  CREATE_ACCOUNTABILITY_REPORT = "create-accountability-report",
  APPROVAL_REQUEST_ACCOUNTABILITY_REPORT = "approval-request-accountability-report",
  UPDATE_ACCOUNTABILITY_EXPENSE = "update-accountability-expense",
  EMPLOYEE_EXPENSES = "employee/expenses",
  ACCOUNTABILITY_EXPENSES = "accountability-expenses",
  THEME_DATA = "theme-data",
  WINTOUR_ERRORS = "wintour-errors",
  CUSTOMER_INVOICES = "customer/invoices",
  CARD_TRANSACTIONS = "expense/card-transactions",
  ORDER_AIRWAY_TRACKER = "order/airway/tracker",
  ADVANCES_SUMMARY = "advances/summary",
  TA_SUMMARY = "travel-analytics/summary",
  TA_TOTAL_SPENT = "travel-analytics/total-spent",
  TA_BY_PRODUCT = "travel-analytics/by-product",
  TA_BY_COST_CENTER = "travel-analytics/by-cost-center",
  TA_BY_UNIT = "travel-analytics/by-unit",
  TA_POLICY_COMPLIANCE = "travel-analytics/policy-compliance",
  TA_ADVANCE_BY_REASON = "travel-analytics/advance-by-reason",
  TA_TOP_VIOLATIONS = "travel-analytics/top-violations",
  TA_POLICY_BY_UNIT = "travel-analytics/policy-by-unit",
  TA_ADVANCE_BY_TRAVELER = "travel-analytics/advance-by-traveler",
  TA_BY_PROJECT = "travel-analytics/by-project",
}
